import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import Handlebars$1 from '@sparta.global.vendors/handlebars';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n"
    + ((stack1 = (lookupProperty(helpers,"construct")||(depth0 && lookupProperty(depth0,"construct"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"structure") : depth0),(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"construct","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":0},"end":{"line":6,"column":46}}})) != null ? stack1 : "")
    + "\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

/* eslint-disable no-console */

/**
 * @export
 * @param {Object} structure structure
 * @param {Object} content content
 * @return {String} constructed str
 */
function construct(structure, content) {
  const {
    attributes,
    children
  } = structure;
  let childContent = '';
  if (children) {
    // eslint-disable-next-line
    for (let child in children) {
      childContent += construct(children[child], content);
    }
  }
  let attrs = '';
  if (attributes) {
    // eslint-disable-next-line
    for (let attr in attributes) {
      attrs += ` ${attr}='${attributes[attr]}'`;
    }
  }
  const htmlContent = content[structure.contentKey] || '';
  let icon = structure.icon || '';
  if (icon) {
    if (icon.length < 3) {
      console.log('>< ERROR: Icon definition should be [name, color, size]');
      icon = '[icon error, check console!]';
    } else {
      icon = Handlebars$1.helpers.use(icon[0], icon[1], icon[2]);
    }
  }
  const result = `<${structure.element}${attrs}>${icon}${htmlContent}${childContent}</${structure.element}>`;
  return new Handlebars$1.SafeString(result);
}

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/generic-content-module",
  "version": "2.0.1",
  "id": "genericContentModule",
  "containerID": "homeLoansGenericContentModule",
  "moduleName": "home-loans-generic-content-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "generic-content-module",
  "data": {
    "init": "genericContentModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        construct
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    construct
  },
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.global.vendors/handlebars": "^4.7.7"
  },
  "stores": []
};

/**
 * @class genericContentModuleJS
 * @extends {Module}
 */
class genericContentModuleJS extends Module {
  /**
   * Creates an instance of genericContentModuleJS.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof genericContentModuleJS
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * @returns {void}
   */
  init() {
    const $secureLinks = $('[href*="[secure-env]"]');
    $secureLinks.each(function linksEach() {
      const $el = $(this);
      $el.attr('href', $el.attr('href').replace('[secure-env]', spaParams.siteParams.secureHost));
    });
    const zCol = document.querySelector('.z-col');
    if (zCol) {
      const resizeObserver = new ResizeObserver(() => {
        const zColHeight = zCol.offsetHeight / 2;
        const r = document.querySelector(':root');
        r.style.setProperty('--heightLarge', zColHeight);
      });
      resizeObserver.observe(zCol);
    }
  }
}
registerModuleClass({
  moduleClass: genericContentModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { genericContentModuleJS as default, moduleConfig };
